module.exports = __webpack_public_path__ + "img/greedyAlgorithms.055483cf.svg";